import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import * as React from 'react';
import { RatioContext } from '../../../ConfigProvider';

function SvgNoResults(props) {
  var ratio = React.useContext(RatioContext);
  return /*#__PURE__*/React.createElement("svg", _objectSpread({
    viewBox: "0 0 64 64",
    width: 64 * ratio,
    height: 64 * ratio,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 57.035,
    cy: 17.134,
    fill: "#E5E5E5",
    r: 1.77
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.305 5.43H9.16a4.725 4.725 0 00-4.725 4.725V42.11a1 1 0 001.71.695c.03-.04.06-.075.085-.115l4-6.25h34.06a4.725 4.725 0 004.725-4.725v-21.56a4.725 4.725 0 00-4.71-4.725z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.93 50.05a1.125 1.125 0 01-.795-1.92A20.395 20.395 0 0051.5 25.733a1.126 1.126 0 112.07-.885 22.645 22.645 0 01-4.825 24.87c-.215.217-.51.337-.815.33zM32.73 56.35A22.63 22.63 0 1141.84 13a1.126 1.126 0 11-.91 2.06 20.375 20.375 0 10.185 37.234 1.125 1.125 0 11.925 2.05 22.472 22.472 0 01-9.31 2.005z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3 59.42c-.3 0-.588-.118-.8-.33l-9.365-9.37a1.125 1.125 0 011.59-1.59l9.37 9.37a1.125 1.125 0 01-.795 1.92zM19 39.624c-.61 0-1.109-.489-1.12-1.1-.07-2.69 2.385-10.76 8.56-13.85 1.72-.86 2.87-.5 3.535 0 1.205.86 1.655 2.69 1.78 4.45 2.85-3.694 8.46-9.384 17.215-11.644a14.145 14.145 0 013.05-.585 1.125 1.125 0 010 2.25 13.36 13.36 0 00-2.455.5c-12.245 3.17-18 13.81-18.08 13.915a1.125 1.125 0 01-2.105-.68c.3-2.24.225-5.706-.715-6.38-.29-.206-.825 0-1.22.184-5.2 2.605-7.37 9.576-7.32 11.785a1.125 1.125 0 01-1.095 1.155H19z",
    fill: "#E5E5E5"
  }));
}

export default SvgNoResults;